import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=73be3ce2&"
import script from "./home-page.vue?vue&type=script&lang=ts&"
export * from "./home-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports